import React from "react";
import{ imageDomain} from "../configC/keys"
import {
  Image,
  //Button,
} from "semantic-ui-react";

const WhereWeDeal = () => {
  //*************** */
  return (
    <section className="padding-gr-outer bgColor-gr1 ">
      
          <div className="inner-gr bgColor-gr1 ">
            <div className="headtitl">
              <div
                className="font-36B color-CornflowerBlue px-20"
              >
                Where <span>We Deal</span>
              </div>
              <p className="font-18B px-20">
              Dwarka(Delhi) and Dwarka Expressway(Gurugram)
              </p>
              <div className="devider">
               
              </div>
            </div>

            <div className="flex-center direction-r2c">
            
            

    {/* dwarka section end */}
     
<div className="">

<div className='card-where text-align-justify ' > {/* direction-rowrev2col dwarkaExp section start*/}
<div className="text-align-center font-24B color-dodgerblue mb-20">Dwarka (Delhi)</div>
 
  <div >
 <div style={{textAlign:'center',}} > 
  <img 
  src={`${imageDomain}/upload/where/DWARKA.jpeg`} alt="expressway" 
  style={{textAlign:'center', maxWidth:"100%", maxHeight:"auto",padding:'0px'}} />
  </div>
  
<p>Dwarka a well planned sub-city of Delhi, developed by the Delhi Development Authority (DDA). with plenty of greenery and open areas. is, located in the South West Delhi district of the National Capital Territory of Delhi. This is one of the largest residential areas in Asia,<br/>
It is also frequently referred to as the “Model Township” and is also thought to be the most organized and cleanest of all parts of Delhi and nearby townships.  Dwarka is also known for its higher quality and much better maintained infrastructure. Dwarka also boasts of some the widest and most developed road network for any colony in Delhi and nearby townships which sets it apart from nearby townships
</p>
  </div>


  <div className="flex-center direction-r2c">
  <div className='flex-value-50 pxy-10'>
  

	<p>The great factor about Dwarka is that it’s well connected with other major parts of the city by using the Delhi Metro. There are a total of 8 metro stations in Dwarka It is very close to both Domestic Airport (about 20 minutes) and International Airport (about 10 minutes)  and is bounded by NH-8, Outer Ring Road, Pankha Road, Najafgarh Road, and the Rewari railway line. The major hub for large corporations in the country, Gurgaon is near to Dwarka.</p>

  
  <p>
  After Chanakyapuri, a 2nd diplomatic enclave is being deliberate in Dwarka for embassies and international missions on 34 hectares. Yashobhoomi is a convention center located in Sector 25, Dwarka, Delhi, India. It is the largest convention center in India and Asia by area, and one of the biggest MICE facilities in the world.Most famous cultural centre in Dwarka is the Rukmini Dwarkadhish Temple which is known as the ISKCON temple.
  </p>
  <p>The residential development here mostly consists of low-rise apartment developments by the DDA and various multi-storey Cooperative Group Housing Society (CGHS) projects. Most of the societies have their own park, temples, parking place, power back up, 24x7 water supply, shops etc inside their boundary walls. Dwarka is having markets in each of its sectors, providing for the daily needs of the residents here</p>

  <p>All necessary facilities like Academic Institutions, Eateries, </p> 
 
</div>
<div className='flex-value-50 pxy-10' >
  
<p>Sports Complexes, Hospitals, Schools, Business Complexes are available in Dwarka </p> 
 
<p>Mount Carmel School, DPS, Dwarka International School, and GD Goenka are some of the prominent names among the many schools located within Dwarka.</p>
 <p> Netaji Subhas University of Technology, Guru Gobind Singh Indraprastha University, National Law University, and Faculty of Law (University of Delhi) are the major colleges located here. 
</p>
<p>Max Hospital,Akash Hospital, Manipal Hospital, Maharaja Agrasen Hospital, Medeor Hospital, and Venkateshwar Hospital, Indra Gandhi International hospital which is a govt. hospital are the major hospitals here. </p>
<p>
There are many sports complex in Dwarka such as DDA Sports Complex, Sector 11; All India Football Federation Headquarters (AIFF), Sector-19; Bal Bhavan Cricket Academy, Sector-12; and Shastri FC Football Academy at BGS International Public School.
</p>
<p>
The 5 star hotels such as Radisson Blu, ITC Welcome, Vivanta By Taj, etc and many restaurants are available in Dwarka. Apart from accommodation one can celebrate any occasions like birthday, marriage party as well as business conference there. 
</p>
<p>
  
</p>
</div>
  </div> 

</div>  
</div> {/* dwarka section end */}
{/* */}
{/* dwarka expressway start */}
     
<div className="">

<div className='card-where text-align-justify ' > {/* direction-rowrev2col dwarkaExp section start*/}
<div className="text-align-center font-24B color-dodgerblue mb-20">Dwarka Expressway (Gurugram)</div>
  <div >
 <div style={{textAlign:'center',}} > 
  <img 
  src={`${imageDomain}/upload/where/expressWay.jpeg`} alt="expressway" 
  style={{textAlign:'center', maxWidth:"100%", maxHeight:"auto",padding:'0px'}} />
  </div>
  
<p>Dwarka Expressway, otherwise referred to as the “Northern Peripheral Road” is an 18 kilometer
long and 150 meters wide stretch being developed to connect Delhi with Gurgaon and Dwarka with
National Highway 8. The Expressway connects with NH 8 at Kherki Daula. It will also pass Pataudi
Road which, along with Dwarka Expressway is buzzing with real estate interest as they are close to
three prominent highways.</p>
  </div>


  <div className="flex-center direction-r2c">
  <div className='flex-value-50 pxy-10'>
  
<div className="font-18B">Closest to Delhi Airport</div>
									<p>Dwarka Expressway manages to have an edge over other highways
like Yamuna Expressway because of its direct connectivity to the Indira Gandhi International
Airport and Gurgaon.</p>
<div className="font-18B">Next Commercial and Residential Hub in the Delhi NCR</div>
                  <p>After Chanakyapuri, another
diplomatic enclave i.e.a place where all the diplomats have their residences and offices is
coming up right along the Dwarka Expressway.</p>
</div>
<div className='flex-value-50 pxy-10' >
  
  <div className="font-18B">Traffic ease on NH8</div>
                  <p>Dwarka Expressway will significantly facilitate a smoother traffic
inflow between Delhi and Gurgaon as a 75 meter wide road runs parallel to it to
evacuate intermediate traffic.</p>
<div className="font-18B">TOP builders in the area</div>
                  <p>In order to match up to the prevailing standards of the millennium
city, Gurgaon and the capital, some renowned names have invested in property in Dwarka
Expressway in the residential, education, hospitality and healthcare sectors.</p>

</div>
  </div> 

  

</div>  {/* dwarkaExp section end */}
</div> 
{/* */}
            </div>
          </div>
       
    </section>
  );
};

export default WhereWeDeal;
